/* eslint-disable react-hooks/refs, react-hooks/use-memo */
import { addWithLimit } from '@yimoka/shared';
import { isEqual } from 'lodash-es';
import { DependencyList, useMemo, useRef } from 'react';

// 保留旧实现的深比较语义：渲染期比较依赖快照，只在深度变化时推进 signal。
export const useDeepMemo: typeof useMemo = (factory, deps) => {
  const ref = useRef<DependencyList | null | undefined>(undefined);
  const signalRef = useRef<number>(0);
  if (deps === undefined || deps === null || !areDeepMemoDependenciesEqual(deps, ref.current)) {
    ref.current = deps;
    signalRef.current = addWithLimit(signalRef.current);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(factory, [signalRef.current]);
};

// areDeepMemoDependenciesEqual 对响应式对象的伪 lodash wrapper 标记安全降级，比较异常时按已变化处理。
function areDeepMemoDependenciesEqual(
  current: DependencyList,
  previous: DependencyList | null | undefined,
): boolean {
  try {
    return isEqual(current, previous);
  } catch {
    // 响应式代理对象可能暴露非函数的 __wrapped__/value；重新计算比让整棵表单树崩溃更安全。
    return false;
  }
}
